import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_AFFILIATE_TRACKERS_GROUPS_ROUTE_NAME = Symbol('admin.affiliates.approved.trackers-settings.tracker-groups');
export const TRANSLATION_GROUP_AFFILIATES_TRACKERS_GROUPS = Symbol('admin.affiliates.approved.trackers-settings.tracker-groups');

export const AFFILIATE_SHOW_TRACKERS_LIST_QUERY = 'affiliate.show-affiliate-trackers-list';
export const AFFILIATE_SHOW_TRACKERS_LIST_API_URL = 'admin/history_of_tracker_groups_changes/list_trackers';

export const AFFILIATE_SHOW_TRACKER_GROUP_ITEM_QUERY = 'affiliate.show-tracker-group-item';
export const AFFILIATE_SHOW_TRACKER_GROUP_ITEM_API_URL = 'admin/history_of_tracker_groups_changes/form_data';

export const AFFILIATE_SHOW_HISTORY_TRACKER_GROUPS_QUERY = 'affiliate.show-history-tracker-groups';
export const AFFILIATE_SHOW_HISTORY_TRACKER_GROUPS_API_URL = 'admin/affiliates/:id/show_tracker_groups';

export const AFFILIATE_SAVE_TRACKER_GROUPS_MUTATION = 'affiliate.save-tracker-groups';
export const AFFILIATE_SAVE_TRACKER_GROUPS_API_URL = 'admin/history_of_tracker_groups_changes/:id';

export const AFFILIATE_DELETE_TRACKER_GROUPS_MUTATION = 'affiliate.delete-tracker-groups';
export const AFFILIATE_DELETE_TRACKER_GROUPS_API_URL = 'admin/history_of_tracker_groups_changes/:id';

export const AFFILIATES_TRACKER_GROUPS_PERMISSIONS = {
  SHOW: new Permission(
    PermissionsList.admin.HISTORY_OF_TRACKER_GROUPS_CHANGES_SHOW,
  ),
  CREATE: new Permission(
    PermissionsList.admin.HISTORY_OF_TRACKER_GROUPS_CHANGES_CREATE,
  ),
  EDIT: new Permission(
    PermissionsList.admin.HISTORY_OF_TRACKER_GROUPS_CHANGES_EDIT,
  ),
  DELETE: new Permission(
    PermissionsList.admin.HISTORY_OF_TRACKER_GROUPS_CHANGES_DELETE,
  ),
};
